class SearchResult {
    constructor(items = [], totalResults = 0) {
        this.items = items;
        this.totalResults = totalResults;
    }

    isEmpty() {
        return this.totalResults === 0;
    }

    getTotal() {
        return this.totalResults;
    }

    getTotalLoaded() {
        return this.items.length;
    }
}

export default SearchResult;
